import { createSlice } from '@reduxjs/toolkit';
import {
  defaultMenuType,
  subHiddenBreakpoint,
  menuHiddenBreakpoint,
} from 'constants/defaultValues';

const initialState = {
  containerClassnames: defaultMenuType,
  subHiddenBreakpoint,
  menuHiddenBreakpoint,
  menuClickCount: 0,
  // if you use menu-sub-hidden as default menu type, set value of this variable to false
  selectedMenuHasSubItems:
    defaultMenuType === ' menu-sub-hidden' ? false : true,
};

const settingsSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    changeSelectedMenuHasSubItems(state, action) {
      state.selectedMenuHasSubItems = action.payload;
    },
    changeDefaultClassnames(state, action) {
      state.containerClassnames = action.payload;
    },
    addContainerClassname(state, { classname, strCurrentClasses }) {
      // const { classname, strCurrentClasses } = action.payload;
      const newClasses =
        !strCurrentClasses.indexOf(classname) > -1
          ? `${strCurrentClasses} ${classname}`
          : strCurrentClasses;
      state.containerClassnames = newClasses;
    },
    clickOnMobileMenu(state, action) {
      const currentClasses = action.payload
        ? action.payload
            .split(' ')
            .filter((x) => x !== '' && x !== 'sub-show-temporary')
        : '';

      let nextClasses = '';
      if (currentClasses.includes('main-show-temporary')) {
        nextClasses = currentClasses
          .filter((x) => x !== 'main-show-temporary')
          .join(' ');
      } else {
        nextClasses = `${currentClasses.join(' ')} main-show-temporary`;
      }
      state.containerClassnames = nextClasses;
      state.menuClickCount = 0;
    },
    setContainerClassnames(state, action) {
      let { clickIndex, strCurrentClasses, selectedMenuHasSubItems } =
        action.payload;
      // console.log(action.payload);
      const currentClasses = strCurrentClasses
        ? strCurrentClasses.split(' ').filter((x) => x !== '')
        : '';
      let nextClasses = '';
      if (!selectedMenuHasSubItems) {
        if (
          currentClasses.includes('menu-default') &&
          (clickIndex % 4 === 0 || clickIndex % 4 === 3)
        ) {
          clickIndex = 1;
        }
        if (
          currentClasses.includes('menu-sub-hidden') &&
          clickIndex % 4 === 2
        ) {
          clickIndex = 0;
        }
        if (
          currentClasses.includes('menu-hidden') &&
          (clickIndex % 4 === 2 || clickIndex % 4 === 3)
        ) {
          clickIndex = 0;
        }
      }

      if (clickIndex % 4 === 0) {
        if (
          currentClasses.includes('menu-default') &&
          currentClasses.includes('menu-sub-hidden')
        ) {
          nextClasses = 'menu-default menu-sub-hidden';
        } else if (currentClasses.includes('menu-default')) {
          nextClasses = 'menu-default';
        } else if (currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-sub-hidden';
        } else if (currentClasses.includes('menu-hidden')) {
          nextClasses = 'menu-hidden';
        }
        clickIndex = 0;
      } else if (clickIndex % 4 === 1) {
        if (
          currentClasses.includes('menu-default') &&
          currentClasses.includes('menu-sub-hidden')
        ) {
          nextClasses = 'menu-default menu-sub-hidden main-hidden sub-hidden';
        } else if (currentClasses.includes('menu-default')) {
          nextClasses = 'menu-default sub-hidden';
        } else if (currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-sub-hidden main-hidden sub-hidden';
        } else if (currentClasses.includes('menu-hidden')) {
          nextClasses = 'menu-hidden main-show-temporary';
        }
      } else if (clickIndex % 4 === 2) {
        if (
          currentClasses.includes('menu-default') &&
          currentClasses.includes('menu-sub-hidden')
        ) {
          nextClasses = 'menu-default menu-sub-hidden sub-hidden';
        } else if (currentClasses.includes('menu-default')) {
          nextClasses = 'menu-default main-hidden sub-hidden';
        } else if (currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-sub-hidden sub-hidden';
        } else if (currentClasses.includes('menu-hidden')) {
          nextClasses = 'menu-hidden main-show-temporary sub-show-temporary';
        }
      } else if (clickIndex % 4 === 3) {
        if (
          currentClasses.includes('menu-default') &&
          currentClasses.includes('menu-sub-hidden')
        ) {
          nextClasses = 'menu-default menu-sub-hidden sub-show-temporary';
        } else if (currentClasses.includes('menu-default')) {
          nextClasses = 'menu-default sub-hidden';
        } else if (currentClasses.includes('menu-sub-hidden')) {
          nextClasses = 'menu-sub-hidden sub-show-temporary';
        } else if (currentClasses.includes('menu-hidden')) {
          nextClasses = 'menu-hidden main-show-temporary';
        }
      }
      if (currentClasses.includes('menu-mobile')) {
        nextClasses += ' menu-mobile';
      }

      state.containerClassnames = nextClasses;
      state.menuClickCount = clickIndex;
    },
  },
});

export const {
  changeSelectedMenuHasSubItems,
  changeDefaultClassnames,
  addContainerClassname,
  clickOnMobileMenu,
  setContainerClassnames,
} = settingsSlice.actions;

export default settingsSlice.reducer;
